// extracted by mini-css-extract-plugin
export default {"ul":"Todolist_ul__iMsm2"};